class VideoEmbed extends HTMLElement {
  constructor() {
    super();
  }

  playVideo() {
    const videoContainer = this.querySelector('.video-container');
    const videoElement = videoContainer.querySelector('video');
    const coverImages = this.querySelectorAll('.video-cover');
    const playButton = this.querySelector('.play-button');
    const contentOverlay = this.querySelector('.content-overlay');

    console.log(coverImages, 'coverImages');
    if (videoContainer) {
      videoContainer.classList.remove('hidden');
      // Hide all cover images
      coverImages.forEach((cover) => {
        console.log('Hiding cover image:', cover);
        cover.classList.add('!hidden');
      });
      if (playButton) playButton.classList.add('hidden');
      if (contentOverlay) contentOverlay.classList.add('hidden');
      videoElement.play();
    }
  }

  playVideoInModal() {
    const modal = this.querySelector('.video-modal');
    const videoContainer = modal.querySelector('.video-container');
    const videoElement = videoContainer.querySelector('video');
    const playButton = this.querySelector('.play-button');
    const contentOverlay = this.querySelector('.content-overlay');

    if (modal) {
      modal.classList.remove('hidden');
      // Only hide the play button and content overlay, keep cover images visible
      if (playButton) playButton.classList.add('!hidden');
      if (contentOverlay) contentOverlay.classList.add('!hidden');
      videoElement.play();
    }
  }

  closeModal() {
    const modal = this.querySelector('.video-modal');
    const videoElement = modal.querySelector('video');
    const playButton = this.querySelector('.play-button');
    const contentOverlay = this.querySelector('.content-overlay');

    if (modal) {
      modal.classList.add('hidden');
      videoElement.pause();
      videoElement.currentTime = 0;
      // Only restore play button and content overlay
      if (playButton) playButton.classList.remove('!hidden');
      if (contentOverlay) contentOverlay.classList.remove('!hidden');
    }
  }

  connectedCallback() {
    console.log('Video embed connected');

    // Handle play button click
    if (this.querySelector('.play-button')) {
      this.querySelector('.play-button').addEventListener('click', () => {
        console.log('Play button clicked');
        if (this.querySelector('.video-modal')) {
          this.playVideoInModal();
        } else {
          this.playVideo();
        }
      });
    }

    // Handle modal close
    if (this.querySelector('.video-modal')) {
      this.querySelector('.video-modal').addEventListener('click', (e) => {
        // Close modal if clicking outside the video container
        if (!e.target.closest('.video-container')) {
          this.closeModal();
        }
      });

      // Add escape key handler for modal
      document.addEventListener('keydown', (e) => {
        if (
          e.key === 'Escape' &&
          !this.querySelector('.video-modal').classList.contains('hidden')
        ) {
          this.closeModal();
        }
      });
    }

    // Handle video end
    const videoElements = this.querySelectorAll('video');
    videoElements.forEach((video) => {
      video.addEventListener('ended', () => {
        if (this.querySelector('.video-modal')) {
          this.closeModal();
        } else {
          // Reset to initial state
          const videoContainer = this.querySelector('.video-container');
          const coverImages = this.querySelectorAll('.video-cover');
          const playButton = this.querySelector('.play-button');
          const contentOverlay = this.querySelector('.content-overlay');

          if (videoContainer) videoContainer.classList.add('hidden');
          // Show all cover images
          coverImages.forEach((cover) => cover.classList.remove('!hidden'));
          if (playButton) playButton.classList.remove('!hidden');
          if (contentOverlay) contentOverlay.classList.remove('!hidden');
        }
      });
    });
  }
}

customElements.define('video-embed', VideoEmbed);
